import { VEHICLE_CONDITION } from "@src/config/id/constant"

export const mapFieldsToObject = (fields: any, value: any, type?: any) => {
    let response: any = {}

    for (let key in fields) {
        if (fields[key]) {

            key = key.toLowerCase()

            switch (type) {
                case 'residential_details': {
                    let extraKeys = ['per_', 'cur_']

                    extraKeys?.forEach((subKey: any) => {
                        if (value[subKey + key]) {
                            response[subKey + key] = value[subKey + key]
                        }
                    })

                    if (value[key]) {
                        response[key] = value[key]
                    }
                    break;
                }

                case 'other_details': {
                    if (['vehicle_condition', 'insurance_type'].includes(key)) {
                        response[key + "_id"] = value[key + "_id"]
                    }else if(key === 'referrer_insurer_name'){
                       response['referrer_name'] = value['referrer_name']
                    }
                    else if(key === 'referrer_insurer_mobile'){
                       response['referrer_mobile'] = value['referrer_mobile']
                    } 
                    
                   else response[key] = value[key]
                    break
                }

                default: {
                    response[key] = value[key]
                    break;
                }
            }
        }
    }

    return response
}


export const callServiceToUpdateLead = (data: any, additionalParams?: any) => {
    
    let requestObj: any = {}
    let keysMapping: any = {
        vehicle_condition: 'vehicle_condition_id',
        insurance_type: 'insurance_type_id',
        vehicle_usage: 'usage_type',
        plate_area_type: 'plate_number_region',
        is_acc: 'is_accessories',
        acc_description: 'accessories_description',
        acc_price: 'accessories_price',
        is_accessories: 'is_acc',
        accessories_description: 'acc_description',
        seat_capacity: 'vehicle_seat',
        name: 'lead_customer_name'
    }

    const dynamicFields = [
        "car_fmv",
        "total_fmv",
        "acc_price",
        "is_accessories",
        "accessories_description",
        "customer_discount",
        "customer_discount_per",
        "addon_detail",
        "insurance_exists",
        "insurance_expire_date",
        "copy_of_insurance",
        "acc_count",
        "existing_insurer_name",
        "rule_engine_id",
        "other_insurer_name",
        "lead_type"
    ];

    let keysToSave = [
        "customer_name", "insurer_id", "vehicle_condition", "user_id", "role_id", "lead_id", "tenure",
        "insurance_type", "insurance_starting_date", "lead_on_behalf_user_id", "vehicle_usage","vehicle_category" ,"vehicle_type", "make", "make_name", "model", "model_name", "version", "version_name", "make_year", "plate_area", "plate_area_type", "machine_number", "plate_number", "chassis_number", "fuel_type", "transmission", "seat_capacity", "car_fmv", "is_acc", "acc_count", "acc_description", "acc_price", "total_fmv", "addon_detail", "ktp_id", "name", "mobile", "dob", "email", "marital_status", "gender", "city_birth", "per_house_no",
        "per_rt", "per_rw", "per_province", "per_city", "per_district", "per_sub_district", "per_sameas_cur", "cur_house_no", "cur_rt", "cur_rw",
        "cur_province", "cur_city", "cur_district", "cur_sub_district", "copy_of_insurance", 'is_shared', 'share_insurer_ids', 'ktp_id', 'partner_id','color','parent_model_id','parent_model_name',
        "insurance_exists", "existing_insurer_name", "insurance_expire_date", "lead_source", "acc_count", "rule_engine_id", "other_insurer_name", 'engine_capacity', 'lead_type'
    ]

    if(data.vehicle_condition_id === VEHICLE_CONDITION['NEW']) {
        dynamicFields.push("bstk_insurer_date");
        keysToSave.push("bstk_insurer_date");
    }

    for (let key of keysToSave) {
        if (keysMapping[key]) {
            requestObj[key] = data[keysMapping[key]]
        } else {
            requestObj[key] = data[key]
        }
    }

    for (let key in additionalParams) {
        if (dynamicFields.includes(key)) {
            const value = (!Array.isArray(additionalParams[key]) && typeof additionalParams[key] === 'object') ? additionalParams[key]?.value : additionalParams[key]
            // set customer value
            
            if (keysMapping[key] && !['acc_price'].includes(key)) {
                requestObj[keysMapping[key]] = value
            }
            else if(['customer_discount','customer_discount_per'].includes(key) && value == undefined){
                requestObj[key] = 0
                
            } 
            else {
                requestObj[key] = value
            }
        }
    }
    return requestObj
}